export enum PlayerActionType {
  BET = 'BET',
  CALL = 'CALL',
  CHECK = 'CHECK',
  RAISE = 'RAISE',
  SB = 'SB',
  BB = 'BB',
  STRADDLE = 'STRADDLE',
  FOLD = 'FOLD',
}
